module.exports = __webpack_public_path__ + "img/byr-banner.8a4741c9.png";